const translations = {
  "en": {
    "Crypto": "Crypto",
    "Information for you": "Information for you",
    "Stocks": "Stocks",
    "Summary": "Summary",
    "Thinking": "Thinking"
  },
  "zh-tw": {
    "Crypto": "加密貨幣",
    "Information for you": "專屬資訊",
    "Stocks": "股票",
    "Summary": "摘要",
    "Thinking": "思考中"
  }
};

export default translations;
